import numeral from "numeral";

export function getOffsetTopByBody (el) {
  let offsetTop = 0
  while (el && el.tagName !== 'BODY') {
    offsetTop += el.offsetTop
    el = el.offsetParent
  }
  return offsetTop
}
export function toCurrencyNumber(dt) {
  if (typeof dt =="string"){
    dt=parseFloat(dt)
  }
  let num = numeral(dt||0);
  let fmt = num.format('0,0.00');
  return fmt;
}
export function toThousands(num) {
  return toCurrencyNumber(num);
}
export function moneyFormatter(row, column, cellValue, index){
  if(cellValue){

    return toThousands(cellValue);
  }else{return null}
}
export function existsInArray(item,arr) {
  for(let i=0;i<arr.length;i++){
    if(arr[i]==item) return true;
  }
  return false;
}
/**
 *对Date的扩展，将 Date 转化为指定格式的String
 *月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 *例子：
 *(new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 *(new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
export function formatDate (date,fmt) {
  let o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
export function safeStr(str){
  if(str!=null){
    return str.replace(/.{1,2}$/,'**');
  }
  return str;
}
export function partDate2FullDate(str){
  if(!str) return str;
  str = str.replaceAll(/[,\/\.]/g,"-").replaceAll(/[年月]/g,"-").replaceAll("日","");
  let parts=str.split("-");
  let rst=[]
  for (let i = 0; i <parts.length ; i++) {
    let p =parts[i];

    p = p.length===1 ? ('0'+p) : p
    rst.push(p);
  }
  return rst.join("-")
}
